{
  "similar": {
    "title": "Similar auctions"
  },
  "related": {
    "set": "More from this set",
    "character": "More of this character",
    "grade": "Same grade",
    "price": "Similar price range"
  },
  "forYou": {
    "title": "Recommended for you"
  },
  "trending": {
    "title": "Trending cards",
    "noPrice": "—",
    "sales": "{count} recent sales"
  },
  "recentlyViewed": {
    "title": "Recently viewed",
    "clear": "Clear"
  },
  "popularSellers": {
    "title": "Popular sellers",
    "fallbackName": "BidNova Seller",
    "new": "New",
    "sales": "{count} sales"
  }
}
